export const packageTemplate = {
  name: "",
  desc: "",
  price: {
    unit: "$",
    value: "",
  },
  image: undefined,
  imageList: [],
  familyMembership: false,
  editConfiguration: {
    imageChanged: false,
  },
  includesTshirt: false,
  sizes: [],
  isDeleted: false,
  hasNoOfChildren: false,
  costPerChild: "",
  hasChildTshirtSizes: false,
  shippingOption: undefined,
  shippingCharge: "",
  pickupNote: "",
  shippingNote: "",
};

export const ProcessingFeeTypes = {
  groupPays: "Group pays (Fees absorbed by group)",
  memberPays: "Member pays (Fees added to total)",
  optional:
    "Ask Member to pay (Request member pay fee but not required)",
};

export const SHIPPING_OPTIONS = [
  "Select shipping option",
  "Show Pickup",
  "Show Shipping",
  "Offer choice of pickup or shipping",
];
